import { ArrowTrendingUpIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getHomePosts, getTrendingPosts } from "../../../slices/2-post/thunk";
import { useNavigate } from "react-router-dom";


const RightSidebar = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { trendingPosts, pagination } = useSelector((state) => state.posts)
    useEffect(() => {
        dispatch(getTrendingPosts({ limit: 6, page: 1, isTrending: 1 }))
    }, [dispatch])
    const locale = i18n.language === "ar" ? "ar" : "en";

    // const trendingData = [
    //     { category: "space", title: "mars_mission", posts: 12400 },
    //     { category: "technology", title: "ai_safety", posts: 8900 },
    //     { category: "science", title: "green_energy", posts: 6700 },
    //     { category: "innovation", title: "smart_city", posts: 5200 },
    //     { category: "tech", title: "quantum_computing", posts: 4100 },
    // ];
    // console.log(trendingPosts)
    return (
        <aside className="fixed end-0 top-0 w-[20rem] h-screen p-4 space-y-4
            bg-bg-light-primary dark:bg-bg-dark-primary
            border-l rtl:border-r border-border-light dark:border-border-dark
            text-gray-900 dark:text-gray-100
            transition-colors overflow-y-auto scrollbar-hide"
        >

            {/* Trending */}
            <div className="p-2 border border-border-light dark:border-border-dark rounded-xl bg-bg-light-secondary dark:bg-bg-dark-secondary ">
                <h2 className="mb-4 font-semibold text-gray-900 cursor-pointer dark:text-gray-100"
                    onClick={() => navigate(`/trending`)}>
                    <ArrowTrendingUpIcon className="inline w-6 h-6 me-2 dark:text-primary text-primary-light" />{t("rightSidebar.trending_now")}
                </h2>
                {trendingPosts?.length > 0 &&
                    <ul className="space-y-1">
                        {trendingPosts?.slice(0, 6)?.map((item, i) => (
                            <li key={i} className="p-2 text-sm text-gray-600 duration-300 rounded-lg cursor-pointer dark:text-gray-400 group dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
                                onClick={() => navigate(`/post/${item?.id}`)}
                            >
                                <p className="text-xs font-medium uppercase text-text-muted-light dark:text-text-muted-dark">
                                    {t(`${item?.isCompany ? (locale === "ar" ? item?.Company?.name_AR : item?.Company?.name_EN) : item?.User?.fullName}`)}
                                </p>

                                <p className="font-semibold text-gray-900 duration-300 dark:text-gray-100 dark:group-hover:text-primary group-hover:text-primary-light">
                                    {t(`${item?.text}`)}
                                </p>

                                <p className="text-xs text-text-muted-light dark:text-text-muted-dark ">
                                    {/* {item?.createdAt?.toLocaleString()} {t("rightSidebar.posts")} */}
                                </p>
                            </li>
                        ))}
                    </ul>
                }
            </div>

            {/* Footer text */}
            <div className="mt-6 space-y-1 text-xs text-center dark:text-text-muted-dark text-text-muted-light lg:text-sm ">
                <p>© 2026 {t("footer.network_name")}</p>
                <p>
                    <a href="/privacy" className="cursor-pointer hover:underline ">{t("footer.privacy")}</a> ·{" "}
                    <a href="/terms-condition" className="cursor-pointer hover:underline">{t("footer.terms")}</a> ·{" "}
                    <a href="/contact" className="cursor-pointer hover:underline">{t("footer.contact")}</a> ·{" "}
                    <a href="/about" className="cursor-pointer hover:underline">{t("footer.about")}</a>
                </p>
            </div>
            {/* Online */}
            {/* <div className="p-2 border border-border-light dark:border-border-dark rounded-xl bg-bg-light-secondary dark:bg-bg-dark-secondary">
                <h2 className="mb-4 font-semibold text-gray-900 dark:text-gray-100">{t("rightSidebar.online_now")}
                </h2>   
                <div className="space-y-1">
                    {onlineUsers.map((user, i) => (
                        <div
                            key={i}
                            className="flex items-center gap-3 p-2 duration-300 rounded-lg cursor-pointer group dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
                        >
                            <div className="relative">
                                <img
                                    src={user.avatar}
                                    alt={user.name}
                                    className="w-8 h-8 rounded-full"
                                />

                                <span
                                    className="
                                    absolute bottom-0 right-0
                                    w-3 h-3 rounded-full
                                    dark:bg-primary
                                    bg-primary-light
                                    shadow-[0_0_6px_rgba(0,255,157,0.9)]
                                    "
                                />
                            </div>

                            <div className="flex flex-col">
                                <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                                    {user.name}
                                </p>
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                    {user.username}
                                </p>
                            </div>
                        </div>
                    ))}

                </div>
            </div> */}
        </aside>
    );
};

export default RightSidebar;
